<template>
    <div class="forbidden-layer">
        <div class="tips-box abs-mm">
            <div class="tip-goose">
                <img class="pct100" src="../assets/images/forbidden-goose.png" alt="">
            </div>
            <div class="tip-text">活动太火爆了,<br/>请您看看其他活动吧</div>
            <div class="tip-btn" @click="jumpUrl('https://cfm.jd.com/jdbt/manage/pages/home.html?channelName=00008')" clstag="A05R|clk_fk_ed">
                <img class="pct100" src="../assets/images/forbidden-btn.png" alt="">
            </div >
            <div class="tip-link" @click="jumpUrl('https://pro.m.jd.com/jdjr/active/4VE6AewA8CFAiLtykFc2wEjbWaVy/index.html?showhead=no&channel=tie')" clstag="A05R|clk_fk_more">探索更多福利 ></div>
        </div>
    </div>
</template>
<style rel="stylesheet/scss" lang="scss">
    .forbidden-layer { min-height: 100vh;background: linear-gradient(180deg, rgba(76, 35, 234, 1) 0%, rgba(50, 2, 197, 1) 100%);}
    .tip-goose {width: 2.65rem;}
    .tip-text {color: #E6DFFF;font-size: 0.17rem;margin-top: 0.15rem;}
    .tip-btn {width: 2.4rem;margin: 0 auto;margin-top: 0.6rem;}
    .tip-link {color: #fff;font-size: 0.14rem;margin-top: 0.22rem;}
</style>
<script type="javascript">
    export default {
        data() {
            return {
                msg: 'hello vue'
            }
        },
        methods: {
            jumpUrl(url) {
                window.location.href = url;
            }
        }
    }
</script>
